import React from "react";
import { Linkedin } from "lucide-react";

const AuthorBox = () => {
  return (
    <div className="border-t border-slate-700 mt-16 pt-8 mb-8">
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-teal-500 to-teal-700 flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
          AB
        </div>
        <div>
          <div className="flex items-center gap-2">
            <span className="text-white font-semibold text-sm">
              Alexander Brovko
            </span>
            <a
              href="https://www.linkedin.com/in/abrovko/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-400 hover:text-teal-300 transition-colors"
              aria-label="Alexander Brovko auf LinkedIn"
            >
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
          <p className="text-gray-400 text-xs mt-0.5">
            Geschäftsführer BROVKO GmbH — KI-Transformation seit 2011
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthorBox;
